module.exports = __webpack_public_path__ + "static/media/login-background.3fce0e86.svg";